<template>
  <b-container ref="container" fluid="true" class="Background">
    <b-row class="LoginPage" align-h="between" align-v="stretch">
      <b-col tag="section" class="SigSurface" lg="5" md="6" order="2" order-md="1">
        <b-row>
          <b-col tag="header">
            <figure class="Logo">
              <img src="../../assets/img/logo/logoSpomo_light.svg" height="60" width="230" alt="logo Spomo"/>
            </figure>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col class="SignEmailForm">
            <b-form tag="section" class="SignBlockForm" novalidate @submit.prevent="onSubmit">
              <b-col class="FormField">
                <div class="FormFieldLabel"> {{ $t("auth.signup.email") }}</div>
                <div class="FormFieldInput">
                  <b-form-input type="email" name="Email" class="FormInput" :placeholder="$t('auth.signup.email')" v-model="email" v-validate.disable="'required|email'" :data-vv-as="$t('auth.signup.email')"  autocomplete="username"></b-form-input>
                  <span class="FormFieldError">{{ errors.first("Email") }}</span>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="FormField">
                <div class="FormFieldLabel">{{ $t("auth.signup.password") }}</div>
                <div class="FormFieldInput">
                  <b-form-input type="password" name="Password" class="FormInput" v-model="password" v-validate.disable="'required|min:6'" :data-vv-as="$t('auth.signup.password')" :placeholder="$t('auth.signup.password')" ref="password"></b-form-input>
                  <span class="FormFieldError">{{ errors.first("Password") }}</span>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="FormField">
                <div class="FormFieldLabel">{{ $t("auth.signup.passwordValidation") }}</div>
                <div class="FormFieldInput">
                  <b-form-input type="password" name="PasswordValidation" class="FormInput" v-model="passwordValidation" v-validate.disable="'required|confirmed:password'" :data-vv-as="$t('auth.signup.passwordValidation')" :placeholder="$t('auth.signup.password')"></b-form-input>
                  <span class="FormFieldError">{{ errors.first("PasswordValidation") }}</span>
                </div>
              </b-col>
              <div class="w-100"></div>
                <p class="TextLabelMention">{{ $t('auth.signup.CGU') }} <router-link :to="'cgu'">{{$t('auth.cguLink')}}</router-link></p>
                <div class="w-100"></div>
                  <b-button class="Button" type="submit" pill>{{ $t("auth.signup.signupBtn") }}</b-button>
                <div>
                <span class="FormFieldError">{{ errorMessage }}</span>
                <p>{{$t('auth.signup.loginRedirectLabel')}}
                  <router-link :to="'login'">{{$t('auth.login.login')}}</router-link>
                </p>
              </div>
            </b-form>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col tag="footer" align-self="center">
            <p class="TextLabelMention">{{ $t('auth.allRightReserved') }}</p>
          </b-col>
        </b-row>
      </b-col>
      
      <b-col tag="nav" class="SocialMediaNav" cols="4" order="1" order-md="2">
        <b-row>
          <b-col>
            <p>{{ $t('auth.followUs') }}</p>
            <b-nav small>
              <b-nav-item class="SocialMediaIcon" href="https://www.instagram.com/spomofr/">
                <b-icon icon="instagram" aria-label="Instagram"></b-icon>
              </b-nav-item>
              <b-nav-item class="SocialMediaIcon" href="https://twitter.com/SpomoFr">
                <b-icon icon="twitter" aria-label="twitter"></b-icon>
              </b-nav-item>
              <b-nav-item class="SocialMediaIcon" href="https://www.linkedin.com/company/spomofr/">
                <b-icon icon="linkedin" aria-label="linkedin"></b-icon>
              </b-nav-item>
              <b-nav-item class="SocialMediaIcon" href="https://www.facebook.com/spomoapplicationsport/">
                <b-icon icon="facebook" aria-label="facebook"></b-icon>
              </b-nav-item>
              <b-nav-item class="SocialMediaIcon" href="https://www.youtube.com/channel/UCd31qFpztATy1RMuDCRgCXw">
                <b-icon icon="youtube" aria-label="youtube"></b-icon>
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LoginHeader from "@/components/Login/Header";
import LoginIcon from "@/components/Login/Icon";
export default {
    components: {
        LoginHeader,
        LoginIcon,
    },
    name: "signup",
    data() {
        return {
            imgIdx:0,
            images: [
              require('@/assets/img/background/background_login_large.jpg'),
              require('@/assets/img/background/kite-surfing.jpeg'),
              require('@/assets/img/background/WindfoilRegate.jpg'),
            ],
            imageTimer:null,
            email: "",
            password: "",
            passwordValidation: "",
            errorMessage: "",
        };
    },
    mounted(){
      this.$refs.container.style.backgroundImage = `url(${this.images[this.imgIdx]})`;
      this.imageTimer = setInterval(this.changeBackground, 5000);
    },
    destroyed(){
      clearInterval(this.imageTimer);
    },
    methods: {
        onSubmit(){
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.$store.dispatch("Auth/signup", {
                  email: this.email,
                  password: this.password,
                })
                .then((data) => {
                  this.$store.dispatch("success", "Login Success");
                  this.$router.replace({
                    name: "home",
                  });
                })
                .catch((error) => {
                  //console.log(error);
                  this.$store.dispatch("error", error.message);
                  this.errorMessage = error.message;
                });
            }
          });
        },
        changeBackground(){
          this.imgIdx = (this.imgIdx+1)%3;
          this.$refs.container.style.backgroundImage = `url(${this.images[this.imgIdx]})`;
        }
    }
};
</script>
